import { FormFields } from '../../../../../models/newSupportCall';
import SupportCallOccurrenceFields from "../SupportCallOccurrenceFields";

export interface ITechnicalFormData {
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
    name: string;
    fetchVehicle: (chassis: string) => Promise<void>;
    occurrenceId?: string;
}

const fieldColumnClassName = 'form-group form-group-lg flex-1-1';

const TechnicalForm = ({ formData, errors, updateField, name, fetchVehicle, occurrenceId }: ITechnicalFormData) => {
    return (
        <>
            <SupportCallOccurrenceFields
                formData={formData}
                errors={errors}
                updateField={updateField}
                name={name}
                fetchVehicle={fetchVehicle}
                subject="TECHNICAL"
                occurrenceId={occurrenceId}
            />
            <div className='margin-top-20'>
                <p className='text-size-16 text-bold'>2. Dados adicionais</p>
                <div className='padding-15 margin-top-20 rounded border'>
                    <div className='display-flex gap-20'>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>Nome da peça causadora *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder="Obrigatório"
                                value={formData.partName}
                                onChange={event => updateField('partName', event.target.value)}
                            />
                            {errors.partName ? <span className='text-size-12 text-color-danger'>{errors.partName}</span> : null}
                        </div>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>Nº AEG</label>
                            <input
                                type='text'
                                className='form-control'
                                value={formData.aeg}
                                onChange={event => updateField('aeg', event.target.value)}
                                placeholder="Opcional"
                            />
                        </div>
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>Qual a reclamação do cliente? *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={formData.customerComment}
                            onChange={event => updateField('customerComment', event.target.value)}
                        />
                        {errors.customerComment ? <span className='text-size-12 text-color-danger'>{errors.customerComment}</span> : null}
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>Diagnóstico / causa da falha *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={formData.diagnose}
                            onChange={event => updateField('diagnose', event.target.value)}
                        />
                        {errors.diagnose ? <span className='text-size-12 text-color-danger'>{errors.diagnose}</span> : null}
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>Reparo necessário *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={formData.repair}
                            onChange={event => updateField('repair', event.target.value)}
                        />
                        {errors.repair ? <span className='text-size-12 text-color-danger'>{errors.repair}</span> : null}
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>Motivo do envio para análise *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={formData.analysisReason}
                            onChange={event => updateField('analysisReason', event.target.value)}
                        />
                        {errors.analysisReason ? <span className='text-size-12 text-color-danger'>{errors.analysisReason}</span> : null}
                    </div>
                </div>
            </div>
        </>
    )
}

export default TechnicalForm;
